// Storage keys used across the application
export const STORAGE_KEYS = {
  APP_STORE: 'deview-app-storage',
} as const;

// Export individual keys for convenience
export const { APP_STORE: APP_STORE_KEY } = STORAGE_KEYS;
